import { render } from "./ISwitch.vue?vue&type=template&id=23dab40e"
import script from "./ISwitch.vue?vue&type=script&lang=js"
export * from "./ISwitch.vue?vue&type=script&lang=js"
script.render = render

export default script